import { render, staticRenderFns } from "./Vue.Svg.Icon.vue?vue&type=template&id=4804f736&scoped=true"
import script from "./Vue.Svg.Icon.vue?vue&type=script&lang=js"
export * from "./Vue.Svg.Icon.vue?vue&type=script&lang=js"
import style0 from "./Vue.Svg.Icon.vue?vue&type=style&index=0&id=4804f736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4804f736",
  null
  
)

export default component.exports